import { render } from "./ClientsPage.vue?vue&type=template&id=eed55b42"
import script from "./ClientsPage.vue?vue&type=script&lang=js"
export * from "./ClientsPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__